export default [
  {
    path: 'student-ask-for-leave',
    name: 'university_student_ask_for_leave',
    meta: {
      title: '请假记录',
    },
    component: () => import('../views/studentAskForLeave/AskForLeaveRecords.vue'),
  },

  {
    path: 'student-create-leave-record',
    name: 'university_student_create_leave_record',
    meta: {
      title: '发起请假',
    },
    component: () => import('../views/studentAskForLeave/Create.vue'),
  },

  {
    path: 'student-leave-record-detail',
    name: 'university_student_leave_record_detail',
    meta: {
      title: '请假信息',
    },
    component: () => import('../views/studentAskForLeave/AskForLeaveDetails.vue'),

    props: (route: any) => ({ id: route.query.id }),
  },
]
